import React, { useState, useEffect, useRef } from "react";

import "../../css/Footer.css";

export default function FooterEN(props) {
  return (
    <div className="footer-container">
      <div className="menu-left">
        <p className="txt1">
          Department of Disaster Prevention and Mitigation. Ministry of
          Interior. Thailand
        </p>

        <p className="txt2">กรมป้องกันและบรรเทาสาธารณภัย กระทรวงมหาดไทย</p>

        <p className="txt3">
          3/12 U Thong Nok Road, Dusit Sub-district, Dusit District, Bangkok
          10300
        </p>

        <p className="txt3">Tel: 0-2637-3000</p>

        <p className="txt3">E-mail: saraban_center@disaster.go.th</p>

        <div className="container-icon-footer">
          <div
            className="ic-circle-porpor"
            onClick={(event) => {
              event.preventDefault();
              window.open("https://www.disaster.go.th/intro.php", "_blank");
            }}
          ></div>
          <p
            className="txt2"
            onClick={(event) => {
              event.preventDefault();
              window.open("https://www.disaster.go.th/intro.php", "_blank");
            }}
          >
            DDPM REPORTER
          </p>
          <div
            className="ic-circle-facebook"
            onClick={(event) => {
              event.preventDefault();
              window.open(
                "https://www.facebook.com/DDPMNews/?locale=th_TH",
                "_blank"
              );
            }}
          ></div>
          <p
            className="txt2"
            onClick={(event) => {
              event.preventDefault();
              window.open(
                "https://www.facebook.com/DDPMNews/?locale=th_TH",
                "_blank"
              );
            }}
          >
            DDPM
          </p>
          <div
            className="ic-circle-twitter"
            onClick={(event) => {
              event.preventDefault();
              window.open(
                "https://twitter.com/DDPMNews?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor",
                "_blank"
              );
            }}
          ></div>
          <p
            className="txt2"
            onClick={(event) => {
              event.preventDefault();
              window.open(
                "https://twitter.com/DDPMNews?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor",
                "_blank"
              );
            }}
          >
            @DDPMNews
          </p>
          <div
            className="ic-circle-line"
            onClick={(event) => {
              event.preventDefault();
              window.open(
                "https://page.line.me/155zwaue?openQrModal=true",
                "_blank"
              );
            }}
          ></div>
          <p
            className="txt2"
            onClick={(event) => {
              event.preventDefault();
              window.open(
                "https://page.line.me/155zwaue?openQrModal=true",
                "_blank"
              );
            }}
          >
            @1784DDPM
          </p>
        </div>
      </div>

      <div className="menu-right">
        <div className="container-title-ic-menu-right">
          <div className="ic-24hr"></div>
          <p className="txt1">Report 1784</p>
        </div>
        <p className="txt2">24 hours.</p>
        <a
          className="txt3"
          href="https://www.disaster.go.th/intro.php"
          target="_blank"
          rel="noreferrer"
        >
          www.disaster.go.th
        </a>
      </div>
    </div>
  );
}
